import { Module } from "wrapper6";

var $ = jQuery;

export default class Modals extends Module {

	ready(app) {

		// Newsletter
        new Modal('newsletter-modal', '.open-newsletter-modal');
    }
}

class Modal {

    constructor(ELEMENT, SELECTOR) {

        // Get element
        this.ELEMENT = document.getElementById(ELEMENT);
        if (!this.ELEMENT) return;

        // Get open buttons
        this.OPEN_BUTTONS = document.querySelectorAll(SELECTOR);
        if (this.OPEN_BUTTONS.length === 0) return;

        // Get close buttons
        this.CLOSE_BUTTONS = document.querySelectorAll('.mtt-modal__close, .mtt-modal__overlay');

        // Add event listeners
        this.eventListeners();
    }

    eventListeners() {
        
        // Open modal
        for (let i = 0; i < this.OPEN_BUTTONS.length; i++) {
            this.OPEN_BUTTONS[i].addEventListener('click', this.openModal.bind(this));
        }

        // Close modal
        if (this.CLOSE_BUTTONS.length) {
            for (let i = 0; i < this.CLOSE_BUTTONS.length; i++) {
                this.CLOSE_BUTTONS[i].addEventListener('click', this.closeModal.bind(this));
            }
        }

        // Close on escape
        document.addEventListener('keydown', (e) => {
            e.keyCode === 27 && this.ELEMENT.classList.contains('mtt-modal--show') ? this.closeModal() : ''
        })
    }

    openModal() {
        event.preventDefault();
        this.ELEMENT.classList.add('mtt-modal--show');
    }

    closeModal() {
        this.ELEMENT.classList.remove('mtt-modal--show');
    }
}